import { ASSOCIATE_STATUS } from './constants'
import { getSeparationStatusLabel } from '@/modules/profile/utils/separation'

export const getAssociateStatus = (status, terminationType) => {
  if (!status) {
    return {
      title: 'N/A',
      color: '#6b7280'
    }
  }

  if (status === 'terminated') {
    return {
      title: getSeparationStatusLabel(terminationType),
      color: '#ef4444'
    }
  }

  return ASSOCIATE_STATUS[status]
}
